import { 
  SET_CURRENT_STEP,
  START_ONBOARDING,
  COMPLETE_ONBOARDING,
  SKIP_ONBOARDING,
  SET_ONBOARDING_STEP,
  SET_ONBOARDING_CONTEXT
} from '../actions/types';

const initialState = {
  currentStep: null,
  isActive: false,
  context: null, // 'upload', 'interrogation', 'review', etc.
  step: 0,
  totalSteps: 0,
  completed: false
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_STEP:
      return { ...state, currentStep: action.payload };
    
    case START_ONBOARDING:
      return {
        ...state,
        isActive: true,
        context: action.payload.context,
        step: action.payload.step || 1,
        completed: false
      };
    
    case COMPLETE_ONBOARDING:
      return {
        ...state,
        isActive: false,
        completed: true,
        step: 0
      };
    
    case SKIP_ONBOARDING:
      return {
        ...state,
        isActive: false,
        completed: true,
        step: 0
      };
    
    case SET_ONBOARDING_STEP:
      return {
        ...state,
        context: action.payload.context,
        step: action.payload.step
      };
    
    case SET_ONBOARDING_CONTEXT:
      return {
        ...state,
        context: action.payload.context
      };
    
    default:
      return state;
  }
};

export default onboardingReducer;